import { render, staticRenderFns } from "./processManagement.vue?vue&type=template&id=46c105a4&scoped=true&"
import script from "./processManagement.vue?vue&type=script&lang=ts&"
export * from "./processManagement.vue?vue&type=script&lang=ts&"
import style0 from "./processManagement.vue?vue&type=style&index=0&id=46c105a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c105a4",
  null
  
)

export default component.exports